@if (visible && ride && photos) {
<div class="rvd-wrapper">

    <!-- ── Navigation bar ── -->
    @if (showNav) {
    <div class="rvd-navbar">
        <div class="rvd-navbar-tabs">
            <button class="rvd-navbar-tab rvd-navbar-tab--pending"
                [class.rvd-navbar-tab--active]="activeTab === 'PENDING'"
                (click)="onTabChange('PENDING')">Pending</button>
            <button class="rvd-navbar-tab rvd-navbar-tab--approved"
                [class.rvd-navbar-tab--active]="activeTab === 'APPROVED'"
                (click)="onTabChange('APPROVED')">Approved</button>
            <button class="rvd-navbar-tab rvd-navbar-tab--rejected"
                [class.rvd-navbar-tab--active]="activeTab === 'REJECTED'"
                (click)="onTabChange('REJECTED')">Rejected</button>        </div>
        <div class="rvd-navbar-nav">
            <button class="rvd-nav-btn" (click)="onPrev()" [disabled]="!hasPrev">‹ Prev</button>
            <span class="rvd-nav-count">{{ currentIndex + 1 }} of {{ total }}</span>
            <button class="rvd-nav-btn" (click)="onNext()" [disabled]="!hasNext">Next ›</button>
        </div>
    </div>
    }

    <!-- ── Body ── -->
    <div class="rvd-body mb-3">

        <!-- LEFT: photos -->
        <div class="rvd-left">
            <div class="rvd-left-header">
                <span class="rvd-left-title">End-ride photos</span>
                <span class="rvd-status-badge" [ngClass]="statusClass">{{ photos.status }}</span>
                <a class="rvd-ride-ref rvd-link" [routerLink]="['/rides', ride.rideId]" (click)="onRideClick($event)">#{{ ride.rideId }}</a>
            </div>

            <!-- Parking board photo -->
            <div class="rvd-photo-grid">
                @if (parkingPhoto) {
                <div class="rvd-photo-cell rvd-photo-cell--parking" [class.rvd-photo-cell--clickable]="!!parkingPhoto.url" (click)="parkingPhoto.url && openLightbox(parkingPhoto.label)" (keyup.enter)="parkingPhoto.url && openLightbox(parkingPhoto.label)" [tabindex]="parkingPhoto.url ? 0 : -1" role="button">
                    <span class="rvd-photo-label">{{ parkingPhoto.label }}</span>
                    @if (parkingPhoto.url) {
                    <img [src]="parkingPhoto.url" [alt]="parkingPhoto.label" class="rvd-photo-img" />
                    } @else {
                    <div class="rvd-photo-empty"><span class="rvd-camera-icon">📷</span></div>
                    }
                </div>
                }
            </div>

            <!-- Footer -->
            <div class="rvd-left-footer">
                <span>Distance: {{ ride.distanceKm }} km</span>
            </div>

            <!-- Actions -->
            @if (isPending) {
            <div class="rvd-actions">
                <button class="rvd-btn rvd-btn--reject" (click)="onReject()">✕  Reject</button>
                <button class="rvd-btn rvd-btn--approve" (click)="onApprove()">✔  Approve</button>
            </div>
            }
        </div>

        <!-- RIGHT: info -->
        <div class="rvd-right">

            <!-- Ride -->
            <div class="rvd-card">
                <h4 class="rvd-card-title">Ride</h4>
                <div class="rvd-grid">
                    <div class="rvd-field">
                        <span class="rvd-label">RIDE ID</span>
                        <a class="rvd-link" [routerLink]="['/rides', ride.rideId]" (click)="onRideClick($event)">#{{ ride.rideId }}</a>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">STARTED</span>
                        <span class="rvd-value">{{ ride.startedAt | date:'hh:mm a' }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">ENDED</span>
                        <span class="rvd-value">{{ ride.endedAt | date:'hh:mm a' }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">DURATION</span>
                        <span class="rvd-value">{{ ride.durationSeconds | duration }}</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">DISTANCE</span>
                        <span class="rvd-value">{{ ride.distanceKm }} km</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">COLLECTED</span>
                        <span class="rvd-value">AED {{ ride.totalCollectedAmount }}</span>
                    </div>
                </div>
            </div>

            <!-- Customer -->
            <div class="rvd-card">
                <div class="rvd-card-title-row">
                    <h4 class="rvd-card-title rvd-card-title--inline">Customer</h4>
                    @if (customerDetails()?.status) {
                    <span class="rvd-cust-status"
                        [ngClass]="'rvd-cust-status--' + (customerDetails()!.status | lowercase)">
                        <span class="rvd-cust-status-dot"></span>
                        {{ customerDetails()!.status }}
                    </span>
                    }
                </div>
                <div class="rvd-customer-row">
                    <div class="rvd-avatar">{{ customerInitials }}</div>
                    <div class="rvd-customer-meta">
                        <a class="rvd-link" [routerLink]="ride.customerId ? ['/customers', ride.customerId] : null" (click)="onCustomerClick($event)">{{ ride.customerFirstName }} {{ ride.customerLastName }}</a>
                        @if (customerDetails()) {
                        <span class="rvd-customer-sub">
                            {{ customerDetails()!.totalRides }} rides
                            @if (customerDetails()!.averageFeedbackRating !== null && customerDetails()!.averageFeedbackRating !== undefined) {
                            &nbsp;·&nbsp; ★ {{ customerDetails()!.averageFeedbackRating | number:'1.1-1' }}
                            }
                            @if (customerDetails()!.deviceType) {
                            &nbsp;·&nbsp; {{ customerDetails()!.deviceType }}
                            }
                        </span>
                        }
                    </div>
                </div>
                <div class="rvd-grid mt-10">
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">PHONE</span>
                        <span class="rvd-value">{{ ride.customerPhoneNumber }}</span>
                    </div>
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">EMAIL</span>
                        <span class="rvd-value">{{ ride.customerEmail }}</span>
                    </div>
                </div>
            </div>

            <!-- Car -->
            <div class="rvd-card">
                <h4 class="rvd-card-title">Car</h4>
                <div class="rvd-car-main-row">
                    <div class="rvd-car-thumb">
                        @if (carDetails()?.imageUrl) {
                        <img [src]="carDetails()!.imageUrl" alt="Car" class="rvd-car-thumb-img" />
                        } @else {
                        <span class="rvd-car-thumb-icon">📷</span>
                        }
                    </div>
                    <div class="rvd-car-info">
                        <a class="rvd-link" [routerLink]="ride.carId ? ['/vehicles', ride.carId] : null" (click)="onVehicleClick($event)">{{ ride.plateNo }}</a>
                        @if (carDetails()?.model) {
                        <span class="rvd-car-model">
                            {{ carDetails()!.model.maker }} {{ carDetails()!.model.name }}{{ carDetails()!.model.bodyType ? ' · ' + carDetails()!.model.bodyType : '' }}
                        </span>
                        }
                    </div>
                </div>
                <div class="rvd-grid mt-10">
                    <div class="rvd-field">
                        <span class="rvd-label">FUEL LEVEL</span>
                        <span class="rvd-value">{{ carDetails()?.telemetry?.fuelLevel ?? '—' }}%</span>
                    </div>
                    <div class="rvd-field">
                        <span class="rvd-label">ENGINE</span>
                        <span class="rvd-value">{{ carDetails()?.telemetry?.engineStatus ?? '—' }}</span>
                    </div>
                    <div class="rvd-field rvd-field--full">
                        <span class="rvd-label">END LOCATION</span>
                    @if (ride.telemetryEndLat && ride.telemetryEndLng) {
                        <button type="button" class="rvd-link" (click)="openEndLocation()">Show</button>
                    } @else {
                        <span class="rvd-value">N/A</span>
                    }
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
}

<!-- ── Lightbox ── -->
@if (lightboxOpen && lightboxPhoto) {
<div class="rvd-lightbox-backdrop" (click)="lightboxOpen = false" (keyup.escape)="lightboxOpen = false" tabindex="0" role="dialog" aria-modal="true">
    <div class="rvd-lightbox" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" tabindex="-1">
        <!-- Header -->
        <div class="rvd-lightbox-header">
            <span class="rvd-lightbox-title">Ride ID : #{{ ride.rideId }}</span>
            <button class="rvd-lightbox-close" (click)="lightboxOpen = false">✕</button>
        </div>
        <!-- Image -->
        <div class="rvd-lightbox-body">
            <button type="button" class="rvd-lightbox-nav rvd-lightbox-nav--prev" (click)="lightboxPrev()" [disabled]="lightboxIndex === 0">&#8249;</button>
            <img [src]="lightboxPhoto.url" [alt]="lightboxPhoto.label" class="rvd-lightbox-img" />
            <button type="button" class="rvd-lightbox-nav rvd-lightbox-nav--next" (click)="lightboxNext()" [disabled]="lightboxIndex === allPhotos.length - 1">&#8250;</button>
        </div>
    </div>
</div>
}
